(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mapcuts-design-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mapcuts-design-guide'))customElements.define('mapcuts-design-guide',class extends HTMLElement{
 connectedCallback(){
  if(this.controller)return;this.controller=new AbortController();const signal=this.controller.signal;
  const dialog=this.querySelector('dialog'),opener=this.querySelector('[data-design-open]'),image=this.querySelector('.mc-design-image'),zoom=this.querySelector('[data-design-zoom]');
  opener.addEventListener('click',()=>dialog.showModal(),{signal});
  this.querySelector('[data-design-close]').addEventListener('click',()=>dialog.close(),{signal});
  zoom.addEventListener('click',()=>{const enabled=image.classList.toggle('is-zoomed');zoom.setAttribute('aria-pressed',String(enabled))},{signal});
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()}},{signal});
  dialog.addEventListener('close',()=>{image.classList.remove('is-zoomed');zoom.setAttribute('aria-pressed','false');opener.focus()},{signal});
 }
 disconnectedCallback(){this.controller?.abort();this.controller=null}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mapcuts-options-behavior"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mapcuts-options'))customElements.define('mapcuts-options',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.form=this.closest('form');if(!this.form)return;
  const fields=[...this.querySelectorAll(':scope > .mc-owned-field')];
  if(fields.length>3&&!this.querySelector('.mc-optional-details')){
   const optional=document.createElement('details');optional.className='mc-optional-details';const summary=document.createElement('summary');summary.textContent=this.dataset.detailsLabel;optional.append(summary);
   const colors=document.createElement('div');colors.className='mc-color-fields';const heading=document.createElement('h3');heading.textContent=this.dataset.colorsLabel;colors.append(heading);
   fields.forEach(field=>{if(field.querySelector('.mc-swatch-grid'))colors.append(field);else if(!field.querySelector('[required]')&&!field.dataset.feeId)optional.append(field);});
   const status=this.querySelector('.mc-options-status');if(colors.children.length>1)status.before(colors);if(optional.children.length>1)status.before(optional);
  }
  this.controller=new AbortController();const signal=this.controller.signal;
  this.addEventListener('invalid',event=>{const details=event.target.closest('details');if(details)details.open=true;},{capture:true,signal});
  this.addEventListener('change',event=>{
   const input=event.target;
   if(input.type==='radio'){input.closest('fieldset').querySelector('.mc-chosen').textContent=input.value}
   if(input.type==='file'){const file=input.files[0];input.setCustomValidity(file&&(!['image/jpeg','image/png'].includes(file.type)||file.size>10*1024*1024)?input.dataset.fileError:'');input.reportValidity()}
  },{signal});
  this.form.addEventListener('submit',async event=>{
   event.preventDefault();event.stopImmediatePropagation();
   if(this.busy||!this.form.reportValidity())return;
   const status=this.querySelector('[role=status]'),button=this.form.querySelector('[name=add]');status.textContent='';
   if(button.disabled||button.getAttribute('aria-disabled')==='true')return;
   const data=new FormData(this.form),extras=[];
   for(const [key,value] of [...data.entries()])if((typeof value==='string'&&!value.trim())||(value instanceof File&&!value.size))data.delete(key);
   const quantity=Number(data.get('quantity')||1);
   for(const field of this.querySelectorAll('[data-fee-id]')){
    const input=field.querySelector('input,textarea,select');if(!input?.value.trim())continue;
    if(!field.dataset.feeId){status.textContent=this.dataset.error;return}
    extras.push({id:field.dataset.feeId,quantity});
   }
   this.busy=true;button.disabled=true;this.setAttribute('aria-busy','true');
   try{
    let body=data,headers={Accept:'application/json'};
    if(extras.length){
     const properties={};for(const [key,value] of data.entries())if(key.startsWith('properties['))properties[key.slice(11,-1)]=value;
     const group=crypto.randomUUID();properties._mc_group=group;properties._mc_extras='parent';
     extras.forEach(extra=>extra.properties={_mc_group:group,_mc_extras:'fee'});
     body=JSON.stringify({items:[{id:data.get('id'),quantity,properties},...extras]});headers['Content-Type']='application/json';
    }
    const response=await fetch(this.dataset.addUrl,{method:'POST',body,headers});const result=await response.json();
    if(!response.ok||result.status)throw new Error(typeof result.description==='string'?result.description:this.dataset.error);
    window.location.assign(this.dataset.cartUrl);
   }catch(error){status.textContent=error.message||this.dataset.error;button.disabled=false;this.busy=false;this.removeAttribute('aria-busy')}
  },{capture:true,signal});
 }
 disconnectedCallback(){this.controller?.abort();this.ready=false}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mapcuts-product-polish"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mc-option-sheet'))customElements.define('mc-option-sheet',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  const select=this.querySelector('select'),trigger=this.querySelector('.mc-option-trigger'),dialog=this.querySelector('dialog');
  if(!select||!dialog||typeof dialog.showModal!=='function')return;
  this.dataset.enhanced='true';trigger.hidden=false;
  trigger.addEventListener('click',()=>{this.querySelectorAll('[data-value]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.value===select.value)));dialog.showModal()});
  this.querySelector('[data-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});
  dialog.addEventListener('close',()=>trigger.focus());
  this.querySelectorAll('[data-value]').forEach(button=>button.addEventListener('click',()=>{select.value=button.dataset.value;trigger.querySelector('strong').textContent=select.value;dialog.close();select.dispatchEvent(new Event('change',{bubbles:true}))}));
 }
});
let mcRatingFrame=0;
const mcUpdateRating=()=>{
 mcRatingFrame=0;
 const info=document.querySelector('.product__info-container'),source=document.querySelector('.fera-reviews-header-summary');
 if(!info||!source)return;
 if(info.querySelector('.fera-productDetailRating-widget')){info.querySelector('.mc-live-rating')?.remove();return;}
 const rating=source.querySelector('.fera-averageRating-average-number')?.textContent.trim(),count=source.querySelector('.fera-averageRating-count-total')?.textContent.trim();
 if(!rating||!count)return;
 let link=info.querySelector('.mc-live-rating');
 if(!link){link=document.createElement('button');link.type='button';link.className='mc-live-rating';info.querySelector('.product__title')?.after(link);link.addEventListener('click',()=>document.querySelector('.fera-reviews-header-summary')?.scrollIntoView({behavior:'smooth',block:'center'}))}
 const text=`★ ${rating} (${count})`;if(link.textContent!==text)link.textContent=text;
};
const mcRatingObserver=new MutationObserver(()=>{
 if(!mcRatingFrame)mcRatingFrame=requestAnimationFrame(mcUpdateRating);
});
mcRatingObserver.observe(document.body,{childList:true,subtree:true,characterData:true});
mcUpdateRating();
  } catch(e) { console.error(e); }
})();

})();
